export class Recensione {
  _id: string;
  ean13: string;
  // dtrec: Date;
  dtrec: string;
  testata: {
    codice: string,
    descrizione: string
  };
  filename: string;
  linkDescr: string;
  link: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Recensione.ts